import React from 'react';
import { connect } from 'react-redux';
import { DBTextAreaObjective, ObjectiveFlag, DBRadioButton } from '_components';
import styles from './Common.module.css'

class SpeechPragmatics extends React.Component {

    render() {
        return (
            <div>

                <div className={styles.formRowSetting}>
                <div className={styles.flgCol}>
                     <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} flagText='Pragmatic' />
                    </div>
                    <div className={styles.colHeader}>
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSPRASTATUS'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                    </div>
                            
                    <div className={styles.colRadio}>

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSPRASTATUS'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
                    </div>
                    </div>

                    <div className={styles.formRowSetting}>
                    <div className={styles.flgCol} />
                    <div className={styles.colHeader}>
                        Comments
                    </div>
                    </div>
                <div className={styles.formRowSetting}>
                <div className={styles.col} />
                <div className={styles.colRadio}>
                    <DBTextAreaObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPEECH'
                        entityKeyColumn='OSNO'
                        entityKeyValue={this.props.osno}
                        field='OSPRACOMMENTS'
                        className={styles.textarea}
                    />
                    </div>
                </div>
        
                <div className={styles.formRowSetting}>
                <div className={styles.colInnerFlag}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.socialFlagged} flagText='Social Interaction' />
                   </div>

                   <div className={styles.colInnerHeader}>
                       Social Interaction
                    </div>

                   <div className={styles.colRadio}>
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSPRASOCIAL'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                    </div>   
                            
                    <div className={styles.colRadio}>

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSPRASOCIAL'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
                    </div>
 
                </div>

                <div className={styles.formRowSetting}>
                <div className={styles.colInnerFlag}>
                       <ObjectiveFlag className={styles.flag} flagged={this.props.eyeFlagged} flagText='Eye Contact' />
                   </div>

                   <div className={styles.colInnerHeader}>
                   Eye Contact
                    </div>

                   <div className={styles.colRadio}>
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSPRAEYE'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                    </div>   
                            
                    <div className={styles.colRadio}>

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSPRAEYE'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
                    </div>
 
                </div>


                <div className={styles.formRowSetting}>
                <div className={styles.colInnerFlag}>
                     <ObjectiveFlag className={styles.flag} flagged={this.props.initiationFlagged} flagText='Initiation' />
                   </div>

                   <div className={styles.colInnerHeader}>
                   Initiation
                    </div>

                   <div className={styles.colRadio}>
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSPRAINITIATION'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                    </div>   
                            
                    <div className={styles.colRadio}>

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSPRAINITIATION'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
                    </div>
 
                </div>


                <div className={styles.formRowSetting}>
                <div className={styles.colInnerFlag}>
                         <ObjectiveFlag className={styles.flag} flagged={this.props.turnFlagged} flagText='Turn Taking' />
                   </div>

                   <div className={styles.colInnerHeader}>
                       Turn Taking
                    </div>

                   <div className={styles.colRadio}>
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSPRATURN'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                    </div>   
                            
                    <div className={styles.colRadio}>

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSPRATURN'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
                    </div>

                </div>


                <div className={styles.formRowSetting}>
                <div className={styles.colInnerFlag}>
                         <ObjectiveFlag className={styles.flag} flagged={this.props.topicFlagged} flagText='Topic Maintenance' />
                   </div>

                   <div className={styles.colInnerHeader}>
                   Topic Maintenance
                    </div>

                   <div className={styles.colRadio}>
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSPRATOPIC'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                    </div>   
                            
                    <div className={styles.colRadio}>

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSPRATOPIC'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
                    </div>

                </div>

            </div>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let osno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPEECH)
    .find(key => (state.entities.notes.PTOBJECTIVESPEECH[key].OSEVNO === pk && noteType === 1)
        || (state.entities.notes.PTOBJECTIVESPEECH[key].OSNTNO === pk && noteType !== 1)));
        
    return {
        noteId: noteId,
        osno: osno,
        flagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSPRASTATUS !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSPRASTATUS !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSPRASTATUS !== 'WNL'),
        socialFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSPRASOCIAL !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSPRASOCIAL !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSPRASOCIAL !== 'WNL'),
        eyeFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSPRAEYE !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSPRAEYE !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSPRAEYE !== 'WNL'),
        initiationFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSPRAINITIATION !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSPRAINITIATION !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSPRAINITIATION !== 'WNL'),
        turnFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSPRATURN !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSPRATURN !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSPRATURN !== 'WNL'),
        topicFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSPRATOPIC !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSPRATOPIC !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSPRATOPIC !== 'WNL')
    };
}

const connectedSpeechPragmatics = connect(mapStateToProps)(SpeechPragmatics);
export { connectedSpeechPragmatics as SpeechPragmatics };


